import apiClient from "./apiClient";
import {config} from "../config";
import {useQuery} from "@tanstack/react-query";
import {useAppContext} from "../libs/appContextLib";

// Unlike accounts-list, which filters an in-memory frame, this endpoint is a
// Postgres round trip — so don't fire it on a single character.
export const MIN_OPPORTUNITY_SEARCH_LENGTH = 2;

export const useFetchOpportunitySearch = ({debouncedInputValue}) => {
    const {currUser} = useAppContext();
    const trimmedInputValue = (debouncedInputValue || '').trim();

    return useQuery({
        queryKey: [`${currUser.customerId}_opportunities`, trimmedInputValue],
        queryFn: async () => {
            const response = await apiClient.get(
                `${config.REACT_APP_BACKEND_HOST}/opportunities-list`,
                {
                    params: {
                        'search_string': trimmedInputValue
                    }
                }
            )
            return response.data;
        },
        enabled: !!currUser?.customerId && trimmedInputValue.length >= MIN_OPPORTUNITY_SEARCH_LENGTH,
        placeholderData: (previousData) => previousData,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 60 * 36,
        gcTime: 1000 * 60 * 60 * 36,
        retry: false
    })
};
